import { type Html } from 'rune-ts';
import { ButtonAction, ButtonActionProps } from '../../ButtonAction/ButtonAction';
import klass from './Buttons.module.scss';

export const BUTTON_FACTORY_KIND = {
  ALWAYS: 'ALWAYS',
  SOLD_OUT: 'SOLD_OUT',
  MEMBERSHIP: 'MEMBERSHIP',
  DTG: 'DTG',
  NFT: 'NFT',
  LIMITED_TIME: 'LIMITED_TIME',
  LIMITED_QUANTITY: 'LIMITED_QUANTITY',
  COMING_SOON: 'COMING_SOON',
  OUTLINE: 'OUTLINE',
} as const;

export type BaseButtonProps = Omit<ButtonActionProps, 'label'> &
  Partial<Pick<ButtonActionProps, 'label'>> & { kind?: keyof typeof BUTTON_FACTORY_KIND };

export abstract class BaseButtonAction<T extends BaseButtonProps = BaseButtonProps> extends ButtonAction<
  T & { label: string | Html }
> {
  private BUTTON_STYLES = {
    [BUTTON_FACTORY_KIND.ALWAYS]: klass.always,
    [BUTTON_FACTORY_KIND.OUTLINE]: klass.outline,
    [BUTTON_FACTORY_KIND.SOLD_OUT]: klass.sold_out,
    [BUTTON_FACTORY_KIND.MEMBERSHIP]: klass.membership,
    [BUTTON_FACTORY_KIND.DTG]: klass.sold_out,
    [BUTTON_FACTORY_KIND.NFT]: klass.always,
    [BUTTON_FACTORY_KIND.LIMITED_TIME]: klass.limited,
    [BUTTON_FACTORY_KIND.LIMITED_QUANTITY]: klass.limited,
    [BUTTON_FACTORY_KIND.COMING_SOON]: klass.coming_soon,
  };

  constructor(props: T) {
    super({ ...props, label: props?.label ?? '' });
    this.replace();
  }

  private replace() {
    this.data.klass = this.makeKlass();
    this.data.label = this.makeLabel();
    this.data.type = this.makeType();
  }

  protected makeKlass(): ButtonActionProps['klass'] {
    const { kind = BUTTON_FACTORY_KIND.ALWAYS } = this.data;
    return `${this.BUTTON_STYLES[kind]} ${this.data.klass}`;
  }

  protected makeType(): ButtonActionProps['type'] {
    return this.data.type;
  }

  protected makeLabel(): ButtonActionProps['label'] {
    return this.data.label;
  }
}
